import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { forwardRef } from 'react';
import { Box } from '../Box/index.js';

/**
 * Center is used to horizontally and vertically center its child.
 * It uses the flexbox centering technique.
 *
 * ### Documentation
 * - [Examples](https://blockparty.endpoint.com/components/center#usage)
 * <br />
 */
const Center = /*#__PURE__*/forwardRef((props, ref) => {
  return /*#__PURE__*/React__default.createElement(Box, _extends({
    ref: ref,
    alignItems: "center",
    display: "flex",
    justifyContent: "center"
  }, props));
});
/**
 * AbsoluteCenter is used to horizontally and vertically center an element
 * relative to its parent dimensions.
 *
 * It uses the `position: absolute` strategy.
 *
 * ### Documentation
 * - [Examples](https://blockparty.endpoint.com/components/center#absolutely-positioned)
 * <br />
 */
const AbsoluteCenter = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    axis = 'both',
    ...rest
  } = props;
  const centerStyles = {
    horizontal: {
      left: '50%',
      transform: 'translateX(-50%)'
    },
    vertical: {
      top: '50%',
      transform: 'translateY(-50%)'
    },
    both: {
      left: '50%',
      top: '50%',
      transform: 'translate(-50%, -50%)'
    }
  };
  return /*#__PURE__*/React__default.createElement(Box, _extends({
    ref: ref
  }, centerStyles[axis], rest, {
    position: "absolute"
  }));
});
/* ======================================= */
/**
 * Circle automatically centers its children with a circular border radius.
 *
 * ### Documentation
 * - [Examples](https://blockparty.endpoint.com/components/center#circle-variant)
 * <br />
 */
const Circle = /*#__PURE__*/forwardRef((props, ref) => {
  return /*#__PURE__*/React__default.createElement(Center, _extends({
    ref: ref,
    borderRadius: "radiusFull"
  }, props));
});

export { AbsoluteCenter, Center, Circle };
